(function () {
  function sectionHeading(s) {
    var h2 = s.querySelector('h2');
    if (h2) return h2.textContent.trim().toLowerCase();
    var prev = s.previousElementSibling;
    for (var n = 0; prev && n < 2; n++) {
      if (prev.querySelector) {
        var ph = prev.querySelector('h2');
        var pc = prev.querySelectorAll('.multicolumn-card').length;
        if (ph && pc === 0) return ph.textContent.trim().toLowerCase();
      }
      prev = prev.previousElementSibling;
    }
    return '';
  }

  function classify(s) {
    var t = sectionHeading(s);

    if (s.querySelector('.accordion details') && /užduodami klausimai|dažniausiai/.test(t)) {
      return 'accordion-faq';
    }

    var cards = s.querySelectorAll('.multicolumn-card');
    if (!cards.length) return null;

    // Crosslink cloud: every card is a linked title with no description and no image
    if (cards.length >= 3) {
      var isCross = Array.prototype.every.call(cards, function (c) {
        var hasLink = !!c.querySelector('.multicolumn-card__info h3 a');
        var rte = c.querySelector('.multicolumn-card__info > .rte');
        var hasDesc = rte && rte.textContent.trim().length > 10;
        var img = c.querySelector('img');
        return hasLink && !hasDesc && !img;
      });
      if (isCross) return 'crosslink-pills';
    }

    var rte = cards[0].querySelector('.multicolumn-card__info > .rte');
    var hasExpandable = !!s.querySelector('.read_more_less, .desc-short') ||
                        (rte && rte.textContent.trim().length > 20);
    if (!hasExpandable) return null;

    var titleHasLink = !!cards[0].querySelector('.multicolumn-card__info h3 a');
    if (titleHasLink && /veda|kineziterape?u?tai|masažistai|komanda|specialist|gydytoj|terapeut/.test(t)) {
      return 'accordion-specialists';
    }

    return cards.length >= 5 ? 'accordion-symptoms' : 'accordion-cards';
  }

  function init() {
    var sections = document.querySelectorAll('section.shopify-section');
    for (var i = 0; i < sections.length; i++) {
      var s = sections[i];
      if (s.className.match(/accordion-(cards|symptoms|specialists|faq)|crosslink-pills/)) continue;

      var marker = classify(s);
      if (!marker) continue;
      s.classList.add(marker);

      // crosslink-pills and FAQ need no card wiring
      if (marker === 'crosslink-pills' || marker === 'accordion-faq') continue;

      var cards = s.querySelectorAll('.multicolumn-card');
      for (var j = 0; j < cards.length; j++) {
        (function (card, section) {
          var title = card.querySelector('.multicolumn-card__info h3');
          if (!title || title.dataset.accInit) return;
          title.dataset.accInit = '1';
          title.setAttribute('role', 'button');
          title.setAttribute('tabindex', '0');
          title.setAttribute('aria-expanded', 'false');

          if (section.classList.contains('accordion-symptoms')) {
            var anchor = title.querySelector('a[href]');
            var href = anchor ? anchor.getAttribute('href') : null;
            if (href && href !== '#' && href !== '') {
              var rte = card.querySelector('.multicolumn-card__info > .rte');
              if (rte && !rte.querySelector('.symptom-learn-more')) {
                var more = document.createElement('a');
                more.className = 'symptom-learn-more';
                more.href = href;
                more.textContent = 'Sužinoti daugiau →';
                rte.appendChild(more);
              }
            }
          }

          function toggle(e) {
            if (e) { e.preventDefault(); e.stopPropagation(); }
            var open = card.classList.toggle('is-open');
            title.setAttribute('aria-expanded', open ? 'true' : 'false');
          }
          title.addEventListener('click', toggle);
          var links = title.querySelectorAll('a');
          for (var k = 0; k < links.length; k++) {
            links[k].addEventListener('click', toggle);
          }
          title.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
          });
        })(cards[j], s);
      }
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();